import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";
import { useSelector } from "react-redux";
import { AppState } from "store";

function useVoucherPermissions() {
  const { getIsRevisor, hasRelation, getIsAuditor } = useCheckRelations();

  const getCanView = () => hasRelation(AuthEnums.PersonCompanyRelationType.Reports) || getIsRevisor();
  const allowBookKeepingByCustomer = useSelector(
    (store: AppState) => store.auth.selectedCompany.allowBookKeepingByCustomer
  );

  const getCanBookVouchers = () => {
    if (getIsAuditor()) {
      return false;
    }

    return allowBookKeepingByCustomer && hasRelation(AuthEnums.PersonCompanyRelationType.BookingAdminAPI, true);
  };

  return { getCanView, getCanBookVouchers };
}

export default useVoucherPermissions;
